




















































import { Component, Prop, Vue } from "vue-property-decorator";
import { EditWoodInfo as WoodInfoType } from "@/components/reports/partials/show/edit/types/edit-wood-info";

@Component
export default class EditWoodInfo extends Vue {
  @Prop() woodInfo!: WoodInfoType;

  private insertionDirectionOptions = ["rad", "tan"];
}
